<template>
  <v-card-actions :class="{cardAction: isActive}">
    <slot></slot>
    <v-spacer></v-spacer>
    <v-btn
      v-if="!hideCancel"
      text
      class="text-capitalize"
      :data-cy="`${this.name}CancelBtn`"
      @click.stop.prevent="cancel"
      >Cancel</v-btn
    >
    <v-btn
      :loading="this.loading"
      :disabled="this.disabled"
      v-if="update"
      :data-cy="`${this.name}UpdateBtn`"
      color="purple"
      class="v-btn-with-radius white--text"
      @click.stop.prevent="submit"
      >Update</v-btn
    >
    <v-btn
      :loading="this.loading"
      :disabled="this.disabled"
      v-else 
      color="primary"
      :data-cy="`${this.name}SaveBtn`"
      class="v-btn-with-radius"
      @click.stop.prevent="submit"
      >{{`${this.label}`}}</v-btn
    >
  </v-card-actions>
</template>

<script>
export default {
  props: {
    isActive: {
      default: true,
    },
    hideCancel: {
      default: false,
    },
    update: {
      default: false,
    },
    name: {
      default: 'data-cy',
    },
    loading: {
      default: false,
    },
    disabled: {
      default: false,
    },
    label: {
      default: 'save',
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    submit() {
      this.$emit('submit');
    },
  },
};
</script>

<style scoped></style>
